import React from 'react';

const ProgressLine = ({ totalSteps, currentStep }) => {
  const calculateWidth = (index) => {
    if (index === 0) {
      return '12px';
    }
    return `calc((100% - 12px)/(${totalSteps} - 1))`;
  };

  const calculateFullWidth = () => {
    if (currentStep === 0) {
      return '12px';
    } else {
      const stepWidth = `calc((100% - 12px)/(${totalSteps - 1}))`;
      return `calc(12px + (${stepWidth} * ${currentStep - 1}))`;
    }
  };

  return (
    <div className="relative mt-4 flex justify-between items-center w-full h-3 bg-customGray-100 rounded-lg overflow-hidden">
      {Array.from({ length: totalSteps }, (_, index) => (
        <div
          key={index}
          style={{ width: calculateWidth(index) }}
          className={`flex h-full px-1 justify-end items-center`}
        >
          <div
            className={`w-1 h-1 rounded-full transition-colors duration-1000 z-50 ${
              index + 1 <= currentStep ? 'bg-white' : 'bg-customGray-400'
            }`}
          />
        </div>
      ))}
      <div
        style={{ width: calculateFullWidth() }}
        className="absolute flex left-0 right-0 h-full items-center rounded-lg bg-gradient-to-r from-[#00C9BB] to-[#0098CB] transition-width duration-300"
      ></div>
    </div>
  );
};

export default ProgressLine;
